import React from 'react';

function NotFound() {
  return (
    <div style={{ padding: '2rem', textAlign: 'center' }}>
      <h2>404 - Page Not Found</h2>
      <a href="/">Go Home</a>
    </div>
  );
}

export default NotFound;
